(function () {
  // Header: become solid after scrolling on the home page
  function initHeader() {
    var host = document.querySelector('.ss-header-host');
    if (!host) return;
    var onScroll = function () { host.classList.toggle('is-solid', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile drawer
  function initDrawer() {
    var drawer = document.getElementById('ss-drawer');
    if (!drawer) return;
    var open = function () { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('ss-lock'); var b = drawer.querySelector('[data-ss-close]'); if (b) b.focus(); };
    var close = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('ss-lock'); };
    document.querySelectorAll('[data-ss-open-drawer]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-ss-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // Cart: open Dawn's cart drawer if present, keep the "Cart (n)" count in sync
  function initCart() {
    document.querySelectorAll('[data-ss-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') { e.preventDefault(); cd.open(a); }
      });
    });
    var setCount = function (n) { document.querySelectorAll('[data-ss-cart-count]').forEach(function (el) { el.textContent = n; }); };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.cartData && typeof evt.cartData.item_count !== 'undefined') setCount(evt.cartData.item_count);
        else fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      });
    }
  }

  // Rails: arrows
  function initRails(root) {
    (root || document).querySelectorAll('[data-ss-rail]').forEach(function (wrap) {
      if (wrap.dataset.ssReady) return;
      wrap.dataset.ssReady = '1';
      var rail = wrap.querySelector('.ss-rail');
      var prev = wrap.querySelector('.ss-arrow--l');
      var next = wrap.querySelector('.ss-arrow--r');
      if (!rail || !prev || !next) return;
      var update = function () {
        prev.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      };
      prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Footer columns collapse into accordions on phones
  function initFooter() {
    var mq = window.matchMedia('(max-width: 749px)');
    var apply = function () { document.querySelectorAll('.ss-fcol').forEach(function (d) { if (mq.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); }); };
    document.querySelectorAll('.ss-fcol summary').forEach(function (s) { s.addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); }); });
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  function init() { initHeader(); initDrawer(); initCart(); initRails(); initFooter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); initHeader(); initDrawer(); initFooter(); });
})();
